@if (!loading) {
  <form
    [formGroup]="formGroup"
    (submit)="onSubmit()">
    <div class="mb-2">
      <app-verification-validation [key]="validationKey" />
    </div>
    <p>
      Select the offices(s) for {{ capture.provider.fullName }} with relevant outreach attempts:
    </p>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>Office Details</th>
          <th>Fax Status</th>
          <th>Provider Fax Status</th>
        </tr>
      </thead>
      @if (providerOffices.length > 0) {
        <tbody formArrayName="offices">
          @for (providerOffice of providerOffices; track providerOffice; let i = $index) {
            <tr
              [class.selected]="officeSelectedInArray(i)">
              <td>
                <div class="form-check">
                  <label class="form-check-label">
                    <input
                      type="checkbox"
                      [formControlName]="i"
                      class="form-check-input" />
                    <app-office [office]="providerOffice.office" />
                  </label>
                </div>
              </td>
              <td>
                {{ keyedOfficeStatusOptions[providerOffice.office.status]?.display }}
              </td>
              <td [class.status-not-verified]="providerOffice.status !== verifiedProviderOfficeStatus">
                {{ keyedProviderOfficeStatusOptions[providerOffice.status]?.display }}
              </td>
            </tr>
          }
        </tbody>
      }
      @if (providerOffices.length === 0) {
        <tbody>
          <tr>
            <td colspan="99">
              <div class="no-applicable-offices">
                Provider does not have any applicable offices with outbound faxes.
              </div>
            </td>
          </tr>
        </tbody>
      }
    </table>
    <div class="mt-2">
      <div>
        Effective Date:
      </div>
      <div>
        <input
          type="date"
          class="form-control last-outreach-date"
          formControlName="lastOutreachDate" />
      </div>
    </div>
    <div class="mt-2">
      <div>
        Justification:
      </div>
      <div>
        <textarea class="form-control phi" formControlName="notes"></textarea>
      </div>
    </div>
    <div class="alert alert-warning p-1 mt-2 mb-0">
      Note: Saving outreach attempt evidence will automatically verify this capture and its peers, if applicable.
    </div>
    <div class="actions mt-2">
      <button type="submit" class="btn btn-primary" [disabled]="!formValid">
        Save
      </button>
      <button type="button" class="btn btn-secondary" (click)="onCancelClick()">
        Cancel
      </button>
    </div>
  </form>
} @else {
  <mat-spinner />
}

